import { EmailEventStatus, EmailType } from "@/gql/graphql";

export const emailEventMessages = {
  type: {
    [EmailType.AdminBookingHoldingDepositReleaseFailed]:
      "admin: holding deposit release failed",
    [EmailType.AdminBookingNoPayments]: "admin: booking no payments",
    [EmailType.AdminBookingSupplierCancelled]: "admin: supplier cancelled",

    [EmailType.BookingChangeRequestActioned]: "booking change request actioned",
    [EmailType.BookingChangeRequestApproved]: "booking change request approved",
    [EmailType.BookingChangeRequestDeclined]: "booking change request declined",
    [EmailType.BookingChangeRequestPaymentRequest]:
      "booking change request payment request",
    [EmailType.BookingChangeRequestPending]: "booking change request pending",

    [EmailType.BookingPaymentRequestCancelled]:
      "booking payment request cancelled",
    [EmailType.BookingPaymentRequestCaptured]:
      "booking payment request captured",
    [EmailType.BookingPaymentRequestCreated]: "booking payment request created",
    [EmailType.BookingPaymentRequestPending]: "booking payment request pending",

    [EmailType.BookingFuelRefundPending]: "fuel refund: pending",
    [EmailType.BookingFuelRefundSubmitted]: "fuel refund: submitted",
    [EmailType.BookingFuelRefundPaymentSent]: "fuel refund: payment sent",
    [EmailType.BookingFerryRefundPending]: "ferry refund: pending",
    [EmailType.BookingFerryRefundPaymentSent]: "ferry refund: payment sent",

    [EmailType.BookingReport]: "booking report",

    [EmailType.CustomerBookingAbandonedCheckout]:
      "customer: abandoned checkout",
    [EmailType.CustomerBookingCancelled]: "customer: booking cancelled",
    [EmailType.CustomerBookingConfirmed]: "customer: booking confirmed",
    [EmailType.CustomerBookingHoldingDepositReleased]:
      "customer: holding deposit released",
    [EmailType.CustomerBookingPending]: "customer: booking pending",
    [EmailType.CustomerBookingPreDeparture]: "customer: pre-departure",
    [EmailType.CustomerBookingReviewRequest]: "customer: review request",
    [EmailType.CustomerBookingTripStarted]: "customer: trip started",
    [EmailType.CustomerBookingVip]: "customer: vip booking",
    [EmailType.CustomerItineraryFirstLegBooked]:
      "customer: itinerary first leg booked",
    [EmailType.CustomerItineraryAllLegsBooked]:
      "customer: itinerary all legs booked",
    [EmailType.CustomerItineraryLegConfirmed]:
      "customer: itinerary leg confirmed",

    [EmailType.IntegrationJucyExportFailed]: "integration: jucy export failed",
    [EmailType.IntegrationRcmPushFailed]: "integration: rcm push failed",
    [EmailType.IntegrationRcmPushSuccess]: "integration: rcm push success",

    [EmailType.InvoiceIssued]: "invoice issued",
    [EmailType.InvoiceOverdue]: "invoice overdue",
    [EmailType.InvoicePaymentMjml]: "invoice payment",
    [EmailType.InvoicePaymentReceived]: "payment receipt",

    [EmailType.OnboardingOrganisationSignup]: "onboarding: organisation signup",
    [EmailType.OnboardingTradePartnerLead]: "onboarding: trade partner lead",

    [EmailType.QuoteIssued]: "quote issued",

    [EmailType.RelocationAdded]: "relocation added",
    [EmailType.RelocationLineReleased]: "relocation plate released",
    [EmailType.RelocationLineSold]: "relocation plate sold",
    [EmailType.RelocationsExpireLapsed]: "relocations expired",
    [EmailType.RelocationsRemoveBookingFee]: "relocations: booking fee removed",

    [EmailType.RideshareListing]: "rideshare listing",

    [EmailType.CompetitorReport]: "competitor report",

    [EmailType.SupplierBookingAccepted]: "supplier: booking accepted",
    [EmailType.SupplierBookingCancelledAfterConfirmation]:
      "supplier: cancelled after confirmation",
    [EmailType.SupplierBookingCancelledBeforeConfirmation]:
      "supplier: cancelled before confirmation",
    [EmailType.SupplierBookingConfirmed]: "supplier: booking confirmed",
    [EmailType.SupplierBookingPending]: "supplier: booking pending",
    [EmailType.SupplierBookingPendingReminder]: "supplier: pending reminder",

    [EmailType.DriverAssignmentReviewRequest]:
      "driver assignment: review request",

    [EmailType.WaitlistCreated]: "waitlist created",
    [EmailType.WaitlistMatch]: "waitlist match",

    [EmailType.WorkOrderAssignmentReceiptsUploaded]:
      "work order assignment: receipts uploaded",
    [EmailType.WorkOrderAssignmentReceiptsApproved]:
      "work order assignment: receipts approved",
    [EmailType.WorkOrderQuoteAccepted]: "work order: quote accepted",
    [EmailType.WorkOrderQuoteRejected]: "work order: quote rejected",
    [EmailType.WorkOrderRequested]: "work order: requested",

    [EmailType.ProDriverAppDownloadReminder]:
      "pro driver app download reminder",
    [EmailType.ProDriverAgreementRequested]:
      "pro driver agreement: signature requested",
    [EmailType.ProDriverAgreementSigned]: "pro driver agreement: signed copy",
    [EmailType.ProDriverJobOpeningOffer]: "pro driver job opening: offer",
    [EmailType.ProDriverJobOpeningClosed]: "pro driver job opening: filled",
    [EmailType.ProDriverBroadcast]: "pro driver broadcast",

    [EmailType.NewMessageNotification]: "new message notification",

    [EmailType.IncidentReported]: "incident: reported",
  } satisfies {
    [key in EmailType]: string;
  },

  status: {
    [EmailEventStatus.Accepted]: "accepted",
    [EmailEventStatus.Delivered]: "delivered",
    [EmailEventStatus.Opened]: "opened",
    [EmailEventStatus.Clicked]: "clicked",
    [EmailEventStatus.Unsubscribed]: "unsubscribed",
    [EmailEventStatus.Stored]: "stored",
    [EmailEventStatus.Rejected]: "rejected",
    [EmailEventStatus.Complained]: "complained",
    [EmailEventStatus.PermanentFail]: "permanent fail",
    [EmailEventStatus.TemporaryFail]: "temporary fail",
  } satisfies {
    [key in EmailEventStatus]: string;
  },
};
